"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OnaCharacter() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="252362" id="intelektualno-vlasništvo" className="bg-background text-foreground w-full">
      <div className="w-full bg-primary py-24 px-6 md:px-12 overflow-hidden">
        <div ref={ref} className={`max-w-4xl mx-auto flex flex-col items-center justify-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-primary-foreground text-center font-default mb-8 tracking-widest">
            PRAVNE NAPOMENE
          </h2>
          
          <div className="text-xl md:text-2xl font-bold text-primary-foreground/90 leading-tight text-center font-default space-y-6 max-w-3xl">
            <p>
              Svi materijali, tekstovi i vizualni identiteti zaštićeni su autorskim pravima. Svako neovlašteno kopiranje ili distribucija sadržaja strogo je zabranjena bez izričitog dopuštenja.
            </p>
            <p>
              Poštujete li intelektualno vlasništvo?
            </p>
            <p>
              Naš tim osigurava potpunu pravnu zaštitu svih inovacija i kreativnih rješenja. Vlasništvo nad sadržajem temelj je našeg poslovanja i jamstvo kvalitete koju pružamo našim klijentima.
            </p>
          </div>
        </div>
      </div>
    </section>;
}